import { ref } from 'vue';
import { defineStore } from 'pinia';

const preferencesStore = defineStore(
  'ui-preferences',
  () => {
    const theme = ref<string>();

    const changeTheme = (newTheme: string) => {
      theme.value = newTheme;
    };

    const $reset = () => {
      theme.value = undefined;
    };

    return {
      theme,
      changeTheme,
      $reset,
    };
  },
  // { persist: true },
);

export default preferencesStore;
